import styled from 'styled-components'

import { hideBlockAt, marginBreakpoints } from '../../../../utils/commonAttrs'
import { BaseBlockProps } from '../../../../types/BaseBlockProps'

export const TableWrapper = styled.div<BaseBlockProps>`
  ${({ hiddenAt }) => hideBlockAt({ hiddenAt })};
  ${({ marginBottom }) => marginBreakpoints({ marginBottom }, 16)};

  overflow: auto;
  padding: 1px;
`
